module.exports = __webpack_public_path__ + "img/saba_achal_no.1eddfd49.png";